import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid } from "@mui/material";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { AddData } from "src/app-redux/common-actions";
import { ICompanyProfileItem } from "src/common/typings/companyProfile";
import { formatCompanyProfileData } from "src/common/utils/companyProfile";
import { Loader } from "src/components/atoms/Loader";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonCheckBox from "src/components/CommonCheckBox/CommonCheckBox";

const guiestIvrdec =
  "By allowing guest IVR functionality through the Jan-IT mobile app, you are allowing any user to check into any work order provided the user provides a valid PO # and vendor ID. You are also allowing Jan-IT to capture, and store the user's name, unique device IDs and the device's location information";

const formatPhoneNumber = (phone: string) => phone.replace(/[()'\s-]/g, "");

const handleApiError = (error: any) => {
  console.log(error);
};

export function GuiestIvrSetting(): React.ReactElement {
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const [currentSetting, setCurrentSetting] = React.useState<ICompanyProfileItem | any>({});

  React.useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const withLoader = async (fn: () => Promise<void>) => {
    setLoader(true);
    try {
      await fn();
    } finally {
      setLoader(false);
    }
  };

  const initialData = async () => {
    await withLoader(getcurrentSetting);
  };

  const getcurrentSetting = async () => {
    try {
      const results = (await fetchWrapper.get(
        "get-vendor-detail-by-vend-num"
      )) as ICompanyProfileItem;
      setCurrentSetting(results);
    } catch (error) {
      handleApiError(error);
    }
  };

  const saveCurrentSetting = async () => {
    setLoader(true);
    try {
      const clone = JSON.parse(JSON.stringify(currentSetting));
      clone.phone = formatPhoneNumber(clone.phone);

      try {
        const body = formatCompanyProfileData(clone);
        await dispatch(
          AddData(
            "/update-vendor-detail-by-vend-num",
            "Vendor mobile guest ivr setting updated successfully",
            JSON.stringify(body)
          )
        );
      } catch (error) {
        handleApiError(error);
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <Loader open={loader} data-testid="circular-progress" />
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Grid container direction="row">
            <Grid item xs={12} md={2}>
              <CommonCheckBox
                label={"Allow Jan-IT Mobile Guest IVR"}
                name={"selected"}
                value={currentSetting.allowGuestIVR === 1}
                handleChange={(e: any) => {
                  setCurrentSetting({ ...currentSetting, allowGuestIVR: e.target.checked ? 1 : 0 });
                }}
                marginRight={-2}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Box display={"flex"} mt={1.4} ml={3}>
                <Box color={"gray"}>Vendor ID : </Box>
                <Box ml={2}>{`${currentSetting?.vendorNum || ""}`}</Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box textAlign="right">
                <CommonButton isGreen onClick={saveCurrentSetting}>
                  Update
                </CommonButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <Box
                fontSize={"10px"}
                fontStyle="italic"
                dangerouslySetInnerHTML={{
                  __html: guiestIvrdec,
                }}
              ></Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
